module.exports = __webpack_public_path__ + "static/media/AllWorld.70b68edc.svg";